<template>
    <div class="timeline">
        <p-header :title="title" :showClose="isFullMap" left-btn="幫助" @onLeftBtn="help" @onClose="isFullMap = false" :share-url="shareUrl"/>
        <div class="order-status" v-show="isDispatching && !isFullMap">
            <div class="info">
                <div class="description">
                    <div class="title">{{ order.designated_driver_id > 0 ? '隨機配對中' : '配對中' }}</div>
                    <div class="content">
                        若配對失敗，將於 {{ lastDispatched }} 暫停配對

                        <div v-if="isTransfer">
                            <br>
                            您好：原先任務騎士因故執行異常無法前往，平台為您重新配對新的騎士執行任務。
                        </div>
                    </div>
                </div>
                <router-link class="next" tag="div" :to="{name: 'order', params: {id: orderId}}">
                    查看任務
                    <img src="@/assets/img/next-white.svg">
                </router-link>
            </div>
            <div class="match-buttons">
                <div class="button" @click="showTip = true">加速配對</div>
                <div class="button match" v-if="!order.extend_pairing" @click="extend">延長配對</div>
            </div>
        </div>
        <div class="order-status" v-show="isAppointing && !isFullMap">
            <div class="info">
                <div class="description">
                    <div class="title">指定騎士配對中</div>
                    <div class="content">
                        指定配對倒數 {{ designateTimeText }}...
                    </div>
                </div>
                <router-link class="next" tag="div" :to="{name: 'order', params: {id: orderId}}">
                    查看任務
                    <img src="@/assets/img/next-white.svg">
                </router-link>
            </div>
            <div class="button" @click="showTip = true">加速配對</div>
        </div>
        <div class="order-status red" v-show="isMissing && !isFullMap">
            <div class="info">
                <div class="description">
                    <div class="title">暫停配對</div>
                    <div class="content">
                        您的任務已取消配對
                    </div>
                </div>
                <router-link class="next" tag="div" :to="{name: 'order', params: {id: orderId}}">
                    查看任務
                    <img src="@/assets/img/next-white.svg">
                </router-link>
            </div>
            <div class="button" @click="restart">
                重新隨機配對
                <loading loader="spinner"
                         :active="isLoading"
                         :width="25"
                         :height="25"/>
            </div>
        </div>
        <div class="order-status green" v-show="isDoneDispatch && !isFullMap">
            <div class="info">
                <div class="description">
                    <div class="title">成功配對</div>
                    <div class="content">
                        <img src="@/assets/img/time.svg">
                        馬上出發
                    </div>
                </div>
                <router-link class="next" tag="div" :to="{name: 'order', params: {id: orderId}}">
                    查看任務
                    <img src="@/assets/img/next-white.svg">
                </router-link>
            </div>
        </div>
        <div class="order-status green" v-show="isWaitGoLocation && !isFullMap">
            <div class="info">
                <div class="description">
                    <div class="title">預約成功</div>
                    <div class="content">
                        <img src="@/assets/img/time.svg">
                        任務開始時間 {{ reservedAt }}
                    </div>
                </div>
                <router-link class="next" tag="div" :to="{name: 'order', params: {id: orderId}}">
                    查看任務
                    <img src="@/assets/img/next-white.svg">
                </router-link>
            </div>
        </div>
        <div class="order-designate-driver" v-show="isAppointing && !isFullMap">
            <div class="avatar" :style="designateAvatarStyle"/>
            <div class="name">
                {{ designateName }}
            </div>
        </div>
        <div class="order-designate-driver-info" v-show="isMissing && order.designated_driver_id > 0 && order.designate_type === 'missing'">
            <div class="title">指定騎士忙碌中，無法承接。</div>
            <div class="content">我們已為您<span class="red">暫停配對</span>。</div>
        </div>
        <div class="order-designate-driver-info" v-show="isAppointing || (isDispatching && order.designated_driver_id > 0)">
            <div class="title">若指定騎士忙碌中，無法承接？</div>
            <div class="content" v-if="order.designate_type !== 'missing'">
                我可以接受<span>隨機配對</span>其它的騎士。
            </div>
            <div class="button" v-else @click.stop="changeDesignateMode">
                我只要這位騎士，不然就暫停配對
                <img src="@/assets/img/next-green.svg">
            </div>
        </div>
        <div class="order-driver" v-if="order.driver" v-show="!isFullMap">
            <div class="avatar" :style="driverAvatarStyle"/>
            <div class="info">
                <div class="time">
                    於 {{ acceptedAt }} 成功指定騎士
                </div>
                <div class="name">
                    #{{ order.driver.knight_id }} {{ order.driver.name }}
                </div>
            </div>
            <div class="chat" @click.stop="toDriverChat">
                <img src="@/assets/img/chat-green.svg">
                聯繫
                <div class="count" v-if="count">
                   {{ count }}
                </div>
            </div>
            <div class="donate" @click.stop="showDonate = true">
                <img src="@/assets/img/donate.svg">
                打賞
            </div>
            <div class="tag" v-if="order.driver.id == order.designated_driver_id">指定</div>
        </div>
        <div class="order-payment" v-show="!isFullMap">
            <div class="sum">
                <div class="title">
                    <img v-if="agreementType === 'jcb'" src="@/assets/img/credit/jcb.png">
                    <img v-else-if="agreementType === 'visa'" src="@/assets/img/credit/visa.png">
                    <img v-else-if="agreementType === 'master'" src="@/assets/img/credit/mastercard.png">
                    <img v-else-if="order.agreement_id" src="@/assets/img/credit/card.png">
                    {{ order.pay === 'cash' ? '現金支付' : '線上支付' }}
                </div>
                <div>
                    目前總費用 $ {{ price }}
                </div>
            </div>
            <div class="prepaid" v-if="order.prices.prepaid">
                <div>您已預刷</div>
                <div>$ {{ order.prices.prepaid }}</div>
            </div>
            <div class="expected" v-if="order.expected_price">
                <div>代付金額</div>
                <div>
                    <span>商品總費用約</span>
                    $ {{ expectedPrice }}
                </div>
            </div>
        </div>
        <div :class="{map: !isFullMap}">
            <GmapMap
                    :style="mapClass"
                    :options="{
                   zoomControl: true,
                   mapTypeControl: false,
                   scaleControl: false,
                   streetViewControl: false,
                   rotateControl: false,
                   fullscreenControl: false,
                   disableDefaultUI: false,
                   clickableIcons: false,
                   zoomControlOptions: {
                        position: 3,
                   },
                   styles: [
                       {
                           featureType: 'poi',
                           stylers: [
                               {
                                   visibility: 'off'
                               }
                           ]
                       },
                       {
                           featureType: 'transit',
                           elementType: 'labels.icon',
                           stylers: [
                               {
                                   visibility: 'off'
                               }
                           ]
                       }
                   ],
                   maxZoom: 18,
                 }"
                    :center="center"
                    :zoom="14"
                    @click="clickMap"
                    map-type-id="roadmap"
                    ref="map">
                <GmapMarker
                        :key="index"
                        v-for="(m, index) in locations"
                        :position="{lat: m.latitude, lng: m.longitude}"
                        :clickable="false"
                        :animation="2"
                        :label="{text:(index + 1).toString(), color: '#fff'}"
                        :icon="{
                        url: m.left_at || (locations[index - 1] && !locations[index - 1].left_at) ? require('@/assets/img/map/location.svg') : require('@/assets/img/map/location-green.svg'),
                        origin: {x:0, y:0},
                        labelOrigin: {x:12,y:13},
                        fontFamily: 600,
                    }"
                        @click="center={lat: m.latitude, lng: m.longitude}"/>
                <GmapMarker
                        v-if="driverPosition && !isWaitGoLocation"
                        key="driver"
                        :position="driverPosition"
                        :clickable="false"
                        :animation="2"
                        :icon="{
                        url: require('@/assets/img/map/moto.svg'),
                        origin: {x:0, y:0},
                        labelOrigin: {x:12,y:13},
                        fontFamily: 600,
                    }"
                        :zIndex="1"
                        @click="center=driverPosition"/>
            </GmapMap>
            <div class="map-status" v-show="(isMissing || isAppointing || isDispatching ) && !isFullMap">
                <img src="@/assets/img/timeline-missing.svg" v-show="isMissing">
                <img src="@/assets/img/timeline-dispatching.svg" v-show="isAppointing || isDispatching">
            </div>
        </div>
        <div class="times" v-show="!isFullMap" ref="times">
            <div class="line" :style="lineStyle"/>
            <p-time v-for="(location, index) in locations" :key="location.id" :location="location" :locations="locations" :location-index="index" :order="order" :is-wait-go-location="isWaitGoLocation"/>
        </div>
        <add-donate v-if="showDonate" :order-id="orderId" @onDone="showDonate=false" @onCancel="showDonate = false"/>
        <set-tip v-if="showTip" @onCancel="showTip = false" @onDone="setTip" :default-tip="order.prices.tip"/>
        <tip-modal ref="tipModal"/>
        <tip-up-modal ref="tipUpModal"/>
        <change-designate-mode ref="changeDesignateMode"/>
    </div>
</template>

<script>
    import header from './components/Header';
    import { mapActions, mapGetters } from 'vuex';
    import moment from 'moment';
    import time from './components/Timeline/Time';
    import SetTip from './components/order/AddTip';
    import TipModal from './components/modal/TipReduceModal';
    import TipUpModal from './components/modal/TipUpModal';
    import Swal from 'sweetalert2';
    import Loading from 'vue-loading-overlay';
    import * as apis from '../apis';
    import ChangeDesignateModeModal from "./components/designate/ChangeDesignateModeModal";
    import AddDonate from "./components/order/AddDonate";

    export default {
        name: 'Timeline',
        components: {
            'p-header': header,
            'p-time': time,
            'set-tip': SetTip,
            'tip-up-modal': TipUpModal,
            'tip-modal': TipModal,
            'loading': Loading,
            'change-designate-mode': ChangeDesignateModeModal,
            'add-donate': AddDonate,
        },
        data() {
            return {
                orderId: 0,
                lineStyle: {
                    'height': '0px',
                },
                showTip: false,
                showDonate: false,
                showPigTail: false,
                isLoading: false,
                isLoaded: false,
                center: {lat:25.047846061048485, lng:121.5169639353331},
                timeout: null,
                driverPosition: null,
                isFullMap: false,
                isTransfer: false,
                designateTime: null,
                designateTimeText: '',
            }
        },
        computed: {
            shareUrl() {
                if (!this.order.share_code) {
                    return  null;
                }

                return window.location.origin + this.$router.resolve({name: 'share', params:{ code: this.order.share_code }, query: {utm_source: 'friends', utm_medium: 'share'}}).href;
            },
            designateAvatarStyle() {
                let url = require('@/assets/img/driver/default-avatar.svg');
                if (this.order.designated_driver && this.order.designated_driver.avatar) {
                    url = this.order.designated_driver.avatar.url;
                }
                return {
                    'background-image': `url("${url}")`
                }
            },
            driverAvatarStyle() {
                let url = require('@/assets/img/driver/default-avatar.svg');
                if (this.order.driver && this.order.driver.avatar) {
                    url = this.order.driver.avatar.url;
                }
                return {
                    'background-image': `url("${url}")`
                }
            },
            designateName() {
                if (this.order.designated_driver) {
                    return `#${this.order.designated_driver.knight_id} ${this.order.designated_driver.name}`
                }
                return '';
            },
            expectedPrice() {
                let price = this.order.expected_price;
                price += this.order.locations
                                .filter(location => location.snapshot)
                                .reduce(
                                    (amount, location) => amount + location.snapshot.reduce(
                                        (amount, product) => amount + (product.sumPrice * product.count), 0
                                    ), 0
                                );
                return price;
            },
            price() {
                if (! this.order.id) {
                    return 0;
                }

                return Math.max(parseInt(this.order.prices.base || 0) +
                    parseInt(this.order.prices.distance || 0) +
                    parseInt(this.order.prices.multiple || 0) +
                    parseInt(this.order.prices.tip || 0) -
                    parseInt(this.order.prices.discount || 0) +
                    parseInt(this.order.prices.wait || 0) +
                    parseInt(this.order.prices.fee || 0) +
                    parseInt(this.order.prices.behalf || 0), 0)
            },
            isDispatching() {
                return this.order.status === 'dispatching' || this.order.status === 'sending';
            },
            isAppointing() {
                return this.order.status === 'appointing';
            },
            isProcessing() {
                return this.order.status === 'processing';
            },
            isDoneDispatch() {
                return this.order.status === 'processing' && (! this.order.reserved_at || this.locations[0].arrived_at);
            },
            isWaitGoLocation() {
                return this.order.status === 'processing' && this.order.reserved_at && ! this.locations[0].arrived_at;
            },
            isMissing() {
                return this.order.status === 'missing';
            },
            title() {
                return `任務編號 #${this.orderId}`;
            },
            locations() {
                return this.order.locations || [];
            },
            acceptedAt() {
                if (! this.order.accepted_at) {
                    return '';
                }

                let time = moment(this.order.accepted_at);

                return time.isSame(moment(), 'day') ? time.format('HH:mm') : time.format('MM/DD HH:mm')
            },
            reservedAt() {
                if (! this.order.reserved_at) {
                    return '';
                }

                let time = moment(this.order.reserved_at);

                return time.isSame(moment(), 'day') ? time.format('HH:mm') : time.format('MM/DD HH:mm')
            },
            lastDispatched() {
                if (! this.order.sent_at) {
                    return '';
                }

                let minutes = 60;
                if (this.order.extend_pairing) {
                    minutes = 60 * 24;
                }
                let time = moment(this.order.sent_at).add(minutes, "minutes");

                return time.format('MM/DD HH:mm');
            },
            order() {
                return this.orderById(this.orderId) || {
                    agreement_id: 0,
                    prices: {
                        behalf: 0,
                        base: 0,
                        distance: 0,
                        multiple: 0,
                        wait: 0,
                        tip: 0,
                        discount: 0,
                    }
                };
            },
            agreementType() {
                let agreement = this.agreementById(this.order.agreement_id);
                if (! agreement) {
                    return '';
                }

                return agreement.type;
            },
            mapClass() {
                if (! this.isFullMap) return {
                    height: '200px',
                    width: '100%',
                };

                return {
                    position: 'absolute',
                    top: '52px',
                    bottom: '0px',
                    height: 'auto',
                    width: '100%',
                }
            },
            count() {
                let message = this.unreadMessages.find(message => message.messageable_id == this.order.id);
                if (!message) return 0;

                return message.count;
            },
            ...mapGetters(['orderById', 'getIsLaunch', 'agreementById', 'unreadMessages'])
        },
        methods: {
            clickMap() {
                this.isFullMap = true;
            },
            restart() {
                this.isLoading = true;

                this.restartOrder(this.order.id).then(() => {
                    this.isLoading = false;
                    this.showPigTail = true;
                }).catch(err => {
                    this.isLoading = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                })
            },
            extend() {
                this.isLoading = true;

                this.extendPairing(this.order.id).then(() => {
                    this.isLoading = false;
                }).catch(err => {
                    this.isLoading = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                });
            },
            setTip(tip) {
                this.showTip = false;

                if (tip <= this.order.prices.tip) {
                    this.$refs.tipModal.show();
                    return;
                }

                this.$refs.tipUpModal.show(tip, this.order.id);
            },
            initTimeline() {
                this.$nextTick(() => {
                    this.lineStyle.height =
                        this.$refs.times.lastChild.getBoundingClientRect().top
                        - this.$refs.times.firstChild.getBoundingClientRect().top + 20
                        + 'px';
                })
            },
            checkOrderStatus() {
                if (this.order.status !== 'preparing' &&
                    this.order.status !== 'processing' &&
                    this.order.status !== 'dispatching' &&
                    this.order.status !== 'appointing' &&
                    this.order.status !== 'missing' &&
                    this.order.status !== 'sending') {
                    this.$router.replace({
                        name: 'order',
                        params: {
                            id: this.orderId,
                        }
                    })
                }
            },
            updateMapBounds() {
                if (!this.$refs.map) {
                    return;
                }

                const bounds = new google.maps.LatLngBounds()
                if (this.driverPosition && !this.isWaitGoLocation) {
                    bounds.extend(this.driverPosition);
                    let location = this.locations.find(location => !location.left_at)
                    if (location) bounds.extend({lat: location.latitude, lng: location.longitude});
                } else {
                    for (let m of this.locations) {
                        bounds.extend({lat: m.latitude, lng: m.longitude});
                    }
                }

                this.$refs.map.fitBounds(bounds);
            },
            updateDriverPosition() {
                apis.getPosition(this.orderId).then(res => {
                    if (res.data.status === 'ok' && (this.driverPosition == null || (this.driverPosition.lat != res.data.position.lat && this.driverPosition.lng != res.data.position.lng))) {
                        this.driverPosition = res.data.position;
                        this.updateMapBounds();
                    }
                });
            },
            edit() {
                this.$router.push({
                    name: 'orderEdit',
                    params: {
                        id: this.orderId,
                    },
                });
            },
            help() {
                this.$router.push({
                   name: 'help',
                   params: {
                       id: this.orderId,
                   }
                });
            },
            toDriverChat() {
                this.$router.push({
                    name: 'message',
                    params: {
                        id: this.orderId,
                    },
                });
            },
            donate() {

            },
            setDesignateTime() {
                if (this.designateTime) {
                    clearInterval(this.designateTime);
                }

                if (!this.order || !this.order.designated_at) {
                    return;
                }

                let designatedAt = moment(this.order.designated_at).add(5, 'minutes');
                let now = moment();
                if (designatedAt.isBefore(now)) {
                    return;
                }

                this.designateTime = setInterval(() => {
                    let seconds = designatedAt.diff(moment(), 'seconds');
                    let minutes = 0;
                    if (seconds >= 0) {
                        minutes = parseInt(seconds / 60);
                        seconds = seconds % 60;
                    }

                    if (minutes <= 0 && seconds <= 0) {
                        clearInterval(this.designateTime);
                    }

                    if (seconds < 0) seconds = 0;

                    this.designateTimeText = `${minutes}分${seconds}秒`;
                }, 1000);
            },
            changeDesignateMode() {
                this.$refs.changeDesignateMode.show(this.orderId, this.order.designate_type);
            },
            init() {
                if (this.timeout) {
                    clearInterval(this.timeout);
                }

                if (this.designateTime) {
                    clearInterval(this.designateTime);
                }
                
                this.orderId = this.$route.params.id;
                this.isTransfer = this.$route.query.transfer;
                this.getOrder(this.orderId).then(() => {
                    if (! this.$route.query.new_order) {
                        return;
                    }

                    dataLayer.push({
                        'event': 'order_successful',
                    });
                }).catch(err => {
                    if (err.response.status === 403 || err.response.status === 404) {
                        this.$router.replace({
                            name: 'home'
                        })
                    }
                }).finally(() => {
                    this.isLoaded = true;
                    this.checkOrderStatus();
                    this.updateMapBounds();
                    this.initTimeline();
                    this.updateDriverPosition();
                    this.setDesignateTime();
                    this.timeout = setInterval(() => {
                        this.updateDriverPosition();
                    }, 10 * 1000);
                });
            },
            ...mapActions(['getOrder', 'restartOrder', 'extendPairing'])
        },
        created() {
            this.init();
        },
        beforeDestroy() {
            if (this.timeout) {
                clearInterval(this.timeout);
            }

            if (this.designateTime) {
                clearInterval(this.designateTime);
            }
        },
        watch: {
            order() {
                if (!this.isLoaded) {
                    return;
                }
                this.checkOrderStatus();
                this.initTimeline();
                this.updateMapBounds();
                this.setDesignateTime();
            },
            getIsLaunch() {
                this.initTimeline();
            },
            "$route"(to, from) {
                if (from.name === 'timeline' && from.params.id !== to.params.id) {
                    this.init();
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    .match-buttons {
        display: flex;
        gap: 10px;

        div {
            flex: 1;

            &.match {
              background-color: #F5A623;
            }
        }
    }

    .pig {
        position: relative;

        .pig-tail {
            position: absolute;
            color: #4A90E2;
            right: 6px;
            bottom: -20px;
            font-size: 12px;
            font-weight: 500;
        }
    }

    .order-designate-driver {
        margin: 15px;
        padding: 10px;
        background-color: #4A90E2;
        border-radius: 5px;
        color: white;
        user-select: none;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;

        .avatar {
            margin-right: 15px;
            height: 40px;
            width: 40px;
            border-radius: 90px;
            background-position: 50% 50%;
            background-size: cover;
        }
    }

    .order-designate-driver-info {
        margin: 15px;
        padding: 10px;
        border-radius: 5px;
        background-color: #FAFAFA;
        color: black;
        font-size: 14px;
        text-align: left;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);

        .title {
            font-weight: 500;
        }

        .content {
            span {
                color: #339933;

                &.red {
                    color: #F44336;
                }
            }
        }

        .button {
            color: #4A90E2;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            user-select: none;
        }
    }

    .order-status {
        margin: 15px;
        padding: 10px;
        background-color: #4A90E2;
        border-radius: 5px;
        color: white;
        user-select: none;

        &.red {
            background-color: #F44336;

            .button {
                background-color: #4A4A4A;
            }
        }

        &.green {
            background-color: #339933;

            .button {
                background-color: #4A4A4A;
            }
        }

        .info {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .description {
                text-align: left;

                .title {
                    font-size: 24px;
                    font-weight: 500;
                }

                .content {
                    margin-top: 10px;
                    font-size: 14px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    img {
                        margin-right: 5px;
                    }
                }
            }

            .next {
                font-size: 14px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                cursor: pointer;
            }
        }

        .button {
            margin-top: 10px;
            background-color: #75B5FF;
            padding: 5px;
            border-radius: 6px;
            cursor: pointer;
        }
    }

    .order-driver {
        background-color: #ffffff;
        border-radius: 5px;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        color: #4A4A4A;
        font-size: 13px;
        padding: 15px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        margin: 15px;
        position: relative;

        .avatar {
            height: 40px;
            width: 40px;
            border-radius: 90px;
            background-position: 50% 50%;
            background-size: cover;
            margin-right: 15px;
        }

        .info {
            flex: 1;
            text-align: left;

            .time {
                margin-bottom: 5px;
                color: #9B9B9B;
                font-size: 12px;
            }

            .name {
                color: #000000;
                font-size: 14px;
            }
        }

        .chat, .donate {
            cursor: pointer;
            user-select: none;
            position: relative;
            color: #339933;
            font-size: 14px;
            display: flex;
            padding: 5px;

            img {
                margin-right: 5px;
                width: 20px;
            }

            .count {
                width: 20px;
                height: 20px;
                background-color: #F44336;
                border-radius: 20px;
                color: #FFFFFF;
                font-size: 12px;
                font-weight: 600;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: -5px;
                left: 12px;
                border: #FFFFFF 1px solid;
            }
        }

        .tag {
            position: absolute;
            top: -12px;
            right: 4px;
            background-color: red;
            color: #ffffff;
            padding: 1px 15px;
            font-size: 13px;
            font-weight: 600;
            border: 2px #ffffff solid;
            border-radius: 5px;
        }
    }

    .order-payment {
        background-color: #ffffff;
        border-radius: 5px;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        color: #4A4A4A;
        font-size: 13px;
        padding: 15px;
        box-sizing: border-box;
        margin: 15px;

        .sum {
            color: #000000;
            font-size: 16px;

            .title {
                display: flex;
                align-items: center;
                img {
                    width: 28px;
                    margin-right: 5px;
                }
            }
        }

        .prepaid, .sum, .expected {
            display: flex;
            justify-content: space-between;
            padding: 3px;

            span {
                color: #9B9B9B;
                font-size: 12px;
                margin-right: 5px;
            }
        }

        .detail {
            color: #339933;
            font-size: 14px;
            font-weight: 600;
            display: flex;
            align-content: center;
            justify-content: flex-end;
            margin-top: 10px;

            img {
                height: 20px;
                width: 20px;
            }
        }
    }

    .map {
        position: relative;

        .map-status {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            opacity: 0.5;
            background-color: #000000;
            display: flex;
            align-items: center;
            justify-content: center;
            user-select: none;
        }
    }


    .timeline {
        position: relative;
        flex: 1;

        .tip {
            color: #9B9B9B;
            font-size: 13px;
            line-height: 18px;
            display: flex;
            align-items: center;
            margin-left: 50px;
            position: relative;

            &::after {
                content: url('~@/assets/img/moto-line.svg');
                position: absolute;
                top: 9px;
                left: -21px;
            }
        }

        .times {
            margin: 13px 20px 10px 30px;

            .line {
                width: 1px;
                background-color: #D8D8D8;
                position: absolute;
                margin-left: 6px;
                margin-top: 20px;
            }

            .time {
                user-select: none;
                display: flex;
                margin-top: 10px;
                min-height: 65px;

                .glow {
                    margin-top: 15px;
                    border-radius: 90px;
                    position: relative;
                }

                .task {
                    margin-left: 20px;
                    flex: 1;
                    display: flex;
                    padding: 10px 15px;
                    justify-content: space-between;
                    align-items: center;

                    .content {
                        text-align: left;

                        .status {
                            font-size: 14px;
                            font-weight: 600;
                            display: flex;
                            align-items: center;
                        }

                        .description {
                            font-size: 12px;
                            margin-top: 8px;
                        }
                    }

                    .buttons {
                        .button {
                            background-color: #4a4a4a;
                            border-radius: 12.5px;
                            padding: 3px 10px;
                            font-size: 14px;
                            cursor: pointer;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }

        .err {
            color: #FFFFFF;

            .glow {
                background-color: #F44336 !important;
                box-shadow: 0 0 5px rgba(244,67,54,.2) !important;

                &::after {
                    background-color: rgba(244,67,54,.45) !important;
                }

                &::before {
                    background-color: rgba(244,67,54,.2) !important;
                }
            }

            .task {
                background-color: #F44336 !important;

                .buttons {
                    .button {
                        background-color: #4A4A4A !important;
                    }
                }
            }
        }

        .driver {
            color: #FFFFFF;

            .glow {
                width: 12px;
                height: 12px;
            }

            .task {
                background-color: #339933;
                border-radius: 5px;

                .content {
                    display: flex;
                    align-content: center;
                    justify-content: center;

                    .avatar {
                        height: 40px;
                        width: 40px;
                        border-radius: 90px;
                        background-position: 50% 50%;
                        background-size: cover;
                        margin-right: 15px;
                    }

                    .name {
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }

        .driver-run {
            .glow {
                width: 12px;
                height: 12px;
            }

            .task {
                border-radius: 5px;

                .content {
                    font-size: 14px;
                    .title {
                        font-weight: 600;
                        display: flex;
                        line-height: 25px;

                        img {
                            margin-right: 5px;
                            width: 25px;
                            height: 25px;
                        }
                    }
                }

                .avatar {
                    height: 40px;
                    width: 40px;
                    border-radius: 90px;
                    background-position: 50% 50%;
                    background-size: cover;
                    margin-right: 15px;
                }
            }
        }

        .driver-note {
            .glow {
                width: 12px;
                height: 12px;
            }

            .task {
                background-color: #FAFAFA;
                border-radius: 5px;
                box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
                font-size: 14px;

                .content {
                    span {
                        color: #339933;
                    }
                }

                .button {
                    color: #339933;
                    display: flex;
                    cursor: pointer;
                }
            }
        }

        .appointing {
            color: #FFFFFF;

            .glow {
                width: 12px;
                height: 12px;
                background-color: #339933;
                border-radius: 90px;
                box-shadow: 0 0 5px rgba(0,255,0,.2);
                animation: glow-1 800ms ease-out infinite alternate;

                &::after {
                    content: '';
                    top: 0;
                    left: 0;
                    position:absolute;
                    width:12px;
                    height: 12px;
                    border-radius: 90px;
                    background-color: rgba(51,153,51,.45);
                    animation: glow-2 800ms ease-out infinite alternate;
                }

                &::before {
                    content: '';
                    top: 0;
                    left: 0;
                    position:absolute;
                    width:12px;
                    height: 12px;
                    border-radius: 90px;
                    background-color: rgba(51,153,51,.2);
                    animation: glow-3 800ms ease-out infinite alternate;
                }
            }

            .task {
                background-color: #339933;
                border-radius: 5px;
            }
        }

        .now {
            color: #FFFFFF;

            .glow {
                width: 12px;
                height: 12px;
                background-color: #339933;
                border-radius: 90px;
                box-shadow: 0 0 5px rgba(0,255,0,.2);
                animation: glow-1 800ms ease-out infinite alternate;

                &::after {
                    content: '';
                    top: 0;
                    left: 0;
                    position:absolute;
                    width:12px;
                    height: 12px;
                    border-radius: 90px;
                    background-color: rgba(51,153,51,.45);
                    animation: glow-2 800ms ease-out infinite alternate;
                }

                &::before {
                    content: '';
                    top: 0;
                    left: 0;
                    position:absolute;
                    width:12px;
                    height: 12px;
                    border-radius: 90px;
                    background-color: rgba(51,153,51,.2);
                    animation: glow-3 800ms ease-out infinite alternate;
                }
            }

            .task {
                background-color: #4A90E2;
                border-radius: 5px;

                &.green {
                    background-color: #339933;
                }
            }
        }

        .wait {
            .glow {
                margin-left: -3px;
                width: 18px;
                height: 18px;
                background-color: #D8D8D8;
            }

            .task {
                .content {
                    .description {
                        color: #9b9b9b;
                    }
                }
            }
        }

        .done {
            .task {
                color: #9B9B9B;
            }

            .glow {
                margin-left: -3px;
                width: 18px;
                height: 18px;
                background-color: #fff;

                &::after {
                    content: '';
                    top: 0;
                    left: 0;
                    position: absolute;
                    width: 18px;
                    height: 18px;
                    border-radius: 90px;
                    background-color: rgba(51,153,51, .4);
                }

                &::before {
                    content: "";
                    position: absolute;
                    width: 5px;
                    height: 9px;
                    border-bottom: 2px solid #fff;
                    border-right: 2px solid #fff;
                    transform: rotate(45deg);
                    z-index: 10;
                    top: 2px;
                    left: 6px;
                }
            }
        }

        .last {
            .glow {
                &::after {
                    content: '終點';
                    height: 16px;
                    color: #9B9B9B;
                    font-size: 11px;
                    position: absolute;
                    left: -3px;
                    bottom: -18px;
                    width: 25px;
                }
            }
        }
    }

    @keyframes glow-3 {
        0% {
            transform: scale(1);
        }

        100% {
            transform: scale(2);
        }
    }

    @keyframes glow-2 {
        0% {
            transform: scale(1);
        }

        100% {
            transform: scale(1.6);
        }
    }

    @keyframes glow-1 {
        0% {
            transform:scale(1);
        }
        100% {
            transform:scale(1.2);
        }
    }
</style>
